import {useCurrentHost} from '#imports';

export function useDomainChecker() {
    const currentHost = useCurrentHost();

    function isMaltDotCom(): boolean {
        return currentHost.getCurrentHost().endsWith('malt.com') && !currentHost.getCurrentHost().startsWith('ae.');
    }

    return {
        isMaltDotCom,
    };
}
